import { callIcon, emailIcon } from "assets/icons";
import { LoadingButton } from "components/form";
import React, { useEffect, useState } from "react";
import Query from "./Query";
import { getSupportDataApi } from "services/contantSupport";
import { failMessage } from "utils/toastMessage";

const ContactUs = () => {
  const [loading, setLoading] = useState(false)
  const [contactSupportData, setContactSupportData] = useState({})

  //--------contact-support-details--------------
  useEffect(() => {
    const getSupportData = async () => {
      try {
        setLoading(true)
        const res = await getSupportDataApi()
        if (res?.status === 200) {
          const { questions = [], setting = {} } = res?.data
          setContactSupportData({ questions, setting })
          // console.log('data', questions, setting)
        } else {
          failMessage(res)
        }
      } catch (e) {
        console.log('error', e?.message)
      } finally {
        setLoading(false)
      }
    }
    getSupportData()
  }, [])
  return (
    <>
      <div className="contact_us">
        <h3 className="title">Contact Us</h3>
        <p>{contactSupportData?.setting?.message || ''}</p>
        <div className="button_section">
          <a href="tel:+91 999 111 9191">
            <img src={callIcon} /> <span>{contactSupportData?.setting?.contactNum || ''}</span>
          </a>
          <a href="mailto:support@volt.in">
            <img src={emailIcon} /> <span>{contactSupportData?.setting?.email || ''}</span>
          </a>
        </div>
        <Query {...{ QuestionList: contactSupportData?.questions }} />
      </div>
    </>
  );
};
export default ContactUs;
